// extracted by mini-css-extract-plugin
export var link = "ViewTermsLink-module--link--bf4a5";
export var soft = "ViewTermsLink-module--soft--f02d1";